import Choices from 'choices.js'

// Central display formatter for deal money inputs → "$23,112.94".
// Strips any existing $/commas before parsing so we never double-format
// (the historic $X.X0 doubling), and returns the value untouched if it
// isn't numeric. Only the DISPLAY changes — data-original-value / the value
// the pricing-adjustment solver reads stay clean numbers.
function formatDealMoney(value) {
  // Guard the NaN/blank case FIRST: when value is the number NaN (e.g. an undefined *_cents / 100)
  // or null/undefined/'', the old `if (isNaN(n)) return value` returned NaN, and $(el).val(NaN)
  // writes the literal string "NaN" into the field — which then persists into the deal's state fee
  // fields and later crashes the deal ("NaN".to_d => Money.new(NaN)). Return '' so the field stays
  // blank instead of "NaN". A genuine non-numeric string the user typed is still preserved below.
  if (value === null || value === undefined || value === '' ||
      (typeof value === 'number' && isNaN(value))) return '';
  const n = parseFloat(String(value).replace(/[^0-9.\-]/g, ''));
  if (isNaN(n)) return value;
  return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// Shared: surface a FAILED deal AJAX call to the dealer instead of silently spinning.
// The deal UI historically shipped success-only handlers, so a 500 (e.g. a Money−nil crash in
// calculate, or a rejected trade-in save) left the spinner spinning and the dealer thinking
// "this junk doesn't save". Pull the server's message when it sent JSON, else a generic line,
// clear any stuck recalc spinner, and drop it in the standard .error_explanation banner.
function dealAjaxMessage(xhr, fallback) {
  var msg = fallback || 'Something went wrong — please try again.';
  try {
    var body = xhr && xhr.responseText ? JSON.parse(xhr.responseText) : null;
    if (body) {
      msg = body.error_explanation || body.error || body.message || msg;
    }
  } catch (e) { /* non-JSON body (an HTML 500 page) → keep the fallback */ }
  return msg;
}
function showDealError(xhr, fallback) {
  var msg = dealAjaxMessage(xhr, fallback);
  $(".error_explanation, .alert").remove();
  $('.summary').removeClass('loading'); // release any stuck recalc spinner
  var $forms = $("form.edit_deal, form.new_deal");
  var $anchor = $forms.length ? $forms.first() : $('body');
  $anchor.before("<div class='error_explanation alert alert-danger'>" + msg + "</div>");
  window.scrollTo(0, 0);
}

document.addEventListener('turbo:load', () => {
  // .off('click') FIRST so this binds EXACTLY once — turbo:load can fire repeatedly on the
  // same document (Turbo frame/visit), and a bare .on() stacked a new handler each time, so one
  // click on "Add a trade-in" fired N times and spawned N duplicate rows. (Matches inventory.js.)
  $('a.add_child').off('click').on('click', function(event) {
    event.preventDefault(); // Prevent the default behavior (e.g., link navigation)

    var assoc = $(this).data('association'),
      template_id = $(this).data('template-id') || (assoc + '_fields_template'),
      regexp = new RegExp('new_' + assoc, 'g'),
      new_id = new Date().getTime(),  // Use current timestamp as unique ID
      content = $('#' + template_id).html().replace(regexp, new_id),
      $content = $(content);

    $(this).before($content);

    // Trigger custom event after child content is added
    $(this).trigger("motorlot:child-added", $content);

    return false; // Prevent the default action (like navigating)
  });

  var $el = $('#marketing-usage-graph');
  var data = [
    {
      label: 'Posts',
      data: $el.data('posts')
    },
    {
      label: 'Clicks',
      data: $el.data('clicks')
    },
    {
      label: 'Calls',
      data: $el.data('calls')
    },
    {
      label: 'Leads',
      data: $el.data('leads')
    },
    {
      label: 'Texts',
      data: $el.data('texts')
    }
  ];

  var options = {
    xaxis: {
      mode: 'time',
      timeformat: $el.data('time-format'),
      ticks: $el.data('ticks')
    }
  };

  if ($.plot) $.plot($el, data, options);

  $(".deals .add-cobuyer .add_child, .v2-deal-form .add-cobuyer .add_child").on("motorlot:child-added", function(event, el) {
    // Legacy: cobuyer contact pickers used the jQuery `combobox` plugin. They're now
    // Choices.js (data-choices-target="contactInvSwitcher"), initialized by the universal
    // widget layer / Stimulus — and the `combobox` plugin is no longer bundled, so calling
    // it here threw "combobox is not a function" on every cobuyer add (a console error on
    // the add-cobuyer flow). Guard it so the dead call is a no-op when the plugin is absent.
    if ($.fn.combobox) { $(el).find("select.combobox").combobox(); }
    $(el).find(".contact-form :input").attr("disabled", true);
  });
  
  if ($('input[name="floorplan_type"]:checked').length === 0) {
    $('#active_checkbox').prop('checked', true);
  }

  $('#active_checkbox, #closed_checkbox').on('change', function() {
    if (this.checked) {
      $('#active_checkbox, #closed_checkbox').not(this).prop('checked', false);
    }
  });

  function isWholesaleType() {
    return $('[name="deal[type_of_sale]"]:checked').val() === 'wholesale';
  }

  $('form.new_deal').on('change', 'select[name^="deal[commissions_attributes]"][name$="[user_id]"]', function () {
    if (!isWholesaleType()) {
      var $select = $(this),
          value = $select.val();

      $.ajax({
          url: '/settings/users/' + value + '/commission.json',
          dataType: 'json',
          success: function (data) {
              console.log("AJAX Success:", data);

              var percentageField = $select.closest('fieldset').find('input[name*="[percentage]"]');
              var amountField = $select.closest('fieldset').find('input[name*="[amount]"]');

              console.log("Target Fields - Percentage:", percentageField, "Amount:", amountField);

              if (percentageField.length === 0 || amountField.length === 0) {
                  console.error("Percentage or Amount field not found!");
                  return;
              }
              percentageField.val(data.default_commission).trigger('change');
              amountField.val(data.default_commission_amount).trigger('change');
              
              console.log("Updated fields - Percentage:", percentageField.val(), "Amount:", amountField.val());
          },
          error: function (xhr, status, error) {
              console.error("AJAX Error:", status, error);
          }
      });
    }
  });

  $('form.edit_deal').on('change', 'select[name^="deal[commissions_attributes]"][name$="[user_id]"]', function () {
    if (!isWholesaleType()) {
      var $select = $(this),
          value = $select.val(),
          nameAttr = $select.attr('name');
      var isNewCommission = /\[\d{13,}\]\[user_id\]$/.test(nameAttr); // Checks if index is a timestamp

      if (!isNewCommission) {
          return; // Exit if the commission is saved in the database
      }

      $.ajax({
          url: '/settings/users/' + value + '/commission.json',
          dataType: 'json',
          success: function (data) {
              console.log("AJAX Success:", data);

              var percentageField = $select.closest('fieldset').find('input[name*="[percentage]"]');
              var amountField = $select.closest('fieldset').find('input[name*="[amount]"]');

              console.log("Target Fields - Percentage:", percentageField, "Amount:", amountField);

              if (percentageField.length === 0 || amountField.length === 0) {
                  console.error("Percentage or Amount field not found!");
                  return;
              }
              percentageField.val(data.default_commission).trigger('change');
              amountField.val(data.default_commission_amount).trigger('change');
              
              console.log("Updated fields - Percentage:", percentageField.val(), "Amount:", amountField.val());
          },
          error: function (xhr, status, error) {
              console.error("AJAX Error:", status, error);
          }
      });
    }
  });

  $(document).ready(function () {
    // Only execute if this is a new deal form
    if ($('form.new_deal').length) {
        function isWholesale() {
            return $('input[name="deal[type_of_sale]"][value="wholesale"]').is(':checked');
        }

        function isNewCommission(inputName) {
            return /\[new_commissions\]\[user_id\]$/.test(inputName) || 
                   /\[\d{13,}\]\[user_id\]$/.test(inputName);
        }

        function getCommissionBlock(element) {
            return $(element).closest('fieldset.commission-form');
        }

        function updateNewCommissionFields() {
            let wholesale = isWholesale();

            // Process ALL commission fields, not just new ones
            $('select[name^="deal[commissions_attributes]"][name$="[user_id]"]').each(function () {
                let $block = getCommissionBlock(this);
                let $percentage = $block.find('input[name$="[percentage]"]');
                let $amount = $block.find('input[name$="[amount]"]');

                if (wholesale) {
                    $percentage.val('0');
                    $amount.val('0');
                }
            });
        }

        $('[name="deal[type_of_sale]"]').on('change', function (event) {
          if ($(this).is(':checked')) {
              // Uncheck all others
              $('input[name="deal[type_of_sale]"]').not(this).prop('checked', false);
              // Immediately update ALL commission fields
              updateNewCommissionFields();
          } else {
              // If unchecking the last checked one, re-check it (must have one selected)
              if ($('input[name="deal[type_of_sale]"]:checked').length === 0) {
                  $(this).prop('checked', true);
              }
          }
        });

        // Handling adding new commissions
        $(document).on('click', '.add_child[data-association="commissions"]', function (e) {
            e.preventDefault();
            let timestamp = new Date().getTime();
            let newCommissionForm = $('#commissions_fields_template')
                .clone()
                .removeAttr('id')
                .html(function(i, html) {
                    return html.replace(/new_commissions/g, timestamp);
                })
                .show();

            $('#commission-collapse .accordion-inner').append(newCommissionForm);
            
            // If wholesale is selected, set new fields to zero
            if (isWholesale()) {
                newCommissionForm.find('input[name$="[percentage]"]').val('0');
                newCommissionForm.find('input[name$="[amount]"]').val('0');
            }
        });

        // User selection change handler
        $(document).on('change', 'select[name^="deal[commissions_attributes]"][name$="[user_id]"]', function () {
            let $block = getCommissionBlock(this);
            let $percentage = $block.find('input[name$="[percentage]"]');
            let $amount = $block.find('input[name$="[amount]"]');
            
            if (isWholesale()) {
                $percentage.val('0');
                $amount.val('0');
            }
        });

        // Initialize on page load
        updateNewCommissionFields();
    }
  });

  $(document).ready(function () {
    // Only execute if this is a new deal form
    function isWholesale() {
        return $('input[name="deal[type_of_sale]"][value="wholesale"]').is(':checked');
    }

    function isNewCommission(inputName) {
        return /\[new_commissions\]\[user_id\]$/.test(inputName) || 
               /\[\d{13,}\]\[user_id\]$/.test(inputName);
    }

    function isExistingCommission(inputName) {
        // Matches pattern like deal[commissions_attributes][123][user_id] where 123 is a normal ID
        return /\[\d{1,12}\]\[user_id\]$/.test(inputName);
    }

    function getCommissionBlock(element) {
        return $(element).closest('fieldset.commission-form');
    }

    function updateNewCommissionFields() {
        let wholesale = isWholesale();

        $('select[name^="deal[commissions_attributes]"][name$="[user_id]"]').each(function () {
            let nameAttr = $(this).attr('name');
            let $block = getCommissionBlock(this);
            
            // Only update NEW commissions (with timestamps or "new_commissions")
            if (isNewCommission(nameAttr)) {
                let $percentage = $block.find('input[name$="[percentage]"]');
                let $amount = $block.find('input[name$="[amount]"]');

                if (wholesale) {
                    $percentage.val('0');
                    $amount.val('0');
                }
            }
            // Skip existing commissions (with normal IDs)
        });
    }

    $('[name="deal[type_of_sale]"]').on('change', function (event) {
        if ($(this).is(':checked')) {
            // Uncheck all others
            $('input[name="deal[type_of_sale]"]').not(this).prop('checked', false);
            // Immediately update ALL commission fields
            updateNewCommissionFields();
        } else {
            // If unchecking the last checked one, re-check it (must have one selected)
            if ($('input[name="deal[type_of_sale]"]:checked').length === 0) {
                $(this).prop('checked', true);
            }
        }
    });

    // Handling adding new commissions
    $(document).on('click', '.add_child[data-association="commissions"]', function (e) {
        e.preventDefault();
        let timestamp = new Date().getTime();
        let newCommissionForm = $('#commissions_fields_template')
            .clone()
            .removeAttr('id')
            .html(function(i, html) {
                return html.replace(/new_commissions/g, timestamp);
            })
            .show();

        $('#commission-collapse .accordion-inner').append(newCommissionForm);
        
        // If wholesale is selected, set new fields to zero
        if (isWholesale()) {
            newCommissionForm.find('input[name$="[percentage]"]').val('0');
            newCommissionForm.find('input[name$="[amount]"]').val('0');
        }
    });

    // User selection change handler
    $(document).on('change', 'select[name^="deal[commissions_attributes]"][name$="[user_id]"]', function () {
        let $block = getCommissionBlock(this);
        let nameAttr = $(this).attr('name');
        let $percentage = $block.find('input[name$="[percentage]"]');
        let $amount = $block.find('input[name$="[amount]"]');
        
        // Only update NEW commissions (with timestamps or "new_commissions")
        if (isWholesale() && isNewCommission(nameAttr)) {
            $percentage.val('0');
            $amount.val('0');
        }
    });

    // Initialize on page load
    updateNewCommissionFields();
  }); 
  
  $("form.edit_deal, form.new_deal").on("click", ".edit-inventory-button", function(event) {
    var $button = $(this);
    var $form = $button.closest("form");
    var $inv = $form.find(".edit-inventory");
    
    if ($inv.is(":visible")) {
        $inv.find(':input').prop('disabled', true);
        $inv.hide();
        $button.html("View/edit vehicle");
    } else {
        var inventory_id = $form.find("[name='deal[vehicle_id]']").val();
        
        if (inventory_id) {
            $button.html("Loading...");
            $inv.find(':input').prop('disabled', false).val(null);
            
            $.get("/inventory/" + inventory_id + ".json", function(data) {
                $inv.find(":input").each(function(idx, el) {
                    var $input = $(el);
                    var name = $input.attr("name");
                    var match;
                    var match;
                    if (name && (match = name.match(/deal\[vehicle_attributes\]\[(.+)\]/))) {
                        var field = match[1];
                        $input.val(data.inventory[field]);
                    }
                });
                
                $inv.show();
                $inv.addClass('styled-inner-form');
                $button.html("Hide vehicle details");
            }).fail(function(xhr) {
                // Was a bare success callback → on a 500 the button stuck on "Loading..." with the
                // fields already blanked, looking like data loss. Reset the label and say so — and
                // RE-DISABLE the emptied inputs so a later deal Save can't submit blank
                // vehicle_attributes and overwrite the record.
                $inv.find(':input').prop('disabled', true);
                $button.html("View/edit vehicle");
                showDealError(xhr, "Couldn't load the vehicle details — please try again.");
            });
        }
    }
  });

  $(".deals, .v2-deal-form").on("click", ".remove-cobuyer", function(event) {
      event.preventDefault();

      var $group = $(this).closest(".control-group");

      // mark for destroy
      $group.find("input[name*='[_destroy]']").val("1");

      // hide instead of remove
      $group.hide();
    });

  $('.customer-form').find(':input').attr('disabled', true);
  $('.deals, .v2-deal-form').on('click', '.add-contact', addContact);
  function addContact(event) {
    var $this = $(this),
      originalTitle = $this.attr('title'),
      f, nameField, namespace, vendorFields, vendorLink, addText, removeText, $cb_clear;
    f = $this.closest('.field').siblings('.contact-fields');

    addText = $this.data('add-text') || 'Add new contact';
    removeText = $this.data('remove-text') || 'Remove new contact';

    f.find('fieldset legend').html(addText);

    $cb_clear = $this.closest('.controls').find('.combobox-clear');
    if ($cb_clear.is(":visible")) {
      $cb_clear.click();
    }

    if (f.is(':visible')) {
      $this.html(addText).css('color', '#005580').attr('title', $this.data('title')).attr('data-title', originalTitle);
      f.hide();
      f.find('input,select').not('[id$="account_id"],[id$="user_id"],[class$="contact-country"],[class$="contact-state"]').val('');
      f.find(':input').prop('disabled', true);
    } else {
      f.show().find('legend').css('font-size', '0.85em');
      $this.html(removeText).css('color', 'red').attr('title', $this.data('title')).attr('data-title', originalTitle);
      f.show();
      f.find(':input').prop('disabled', false);
      f.find(':input').not('[id$="account_id"],[id$="user_id"],[class$="contact-country"],[class$="contact-state"]').val(null);
      f.find("input:text").first().focus();

      nameField = f.find('input[name$="[supplier_attributes][first_name]"]');
      if (nameField.length > 0) {
        namespace = nameField.attr('name').replace('[supplier_attributes][first_name]', '');
        $('[name="' + namespace + '[supplier_id]"]').val(null);
        $('[name="' + namespace + '[supplier_type]"]').val('Contact');
      }

      $this.closest('.add-new-supplier').siblings('.vendor.cost').find('.supplier-display-name').val(null);
      $this.closest('.field').siblings('[name$="[contact_id]"]').val(null);

      vendorFields = f.parent().find('.vendor-fields');
      vendorFields.find(':input').attr('disabled', true);
      vendorFields.hide();

      vendorLink = $this.siblings('.add-vendor');
      originalTitle = vendorLink.attr('title');
      vendorLink.html('Add&nbsp;new&nbsp;vendor').css('color', '#005580').attr('title', vendorLink.data('title')).attr('data-title', originalTitle);

    }
    f.addClass('styled-inner-form');

    $(this).trigger('motorlot:contact-added');

    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  $("form.edit_deal, form.new_deal").on("click", ".edit-contact-button", function(event, force_close_param) {
    var $button = $(this);
    var $contact = $button.closest(".control-group.contact");
    var contact_id = $contact.find("[name$=\"[contact_id]\"]").val();
    var force_close = (force_close_param === 'true');
    
    if (contact_id || force_close) {
        var $contact_form = $contact.find(".contact-form");
        
        if ($contact_form.is(":visible") || force_close) {
            $contact_form.find(':input').attr('disabled', true);
            $contact_form.hide();
            $button.html("View/edit contact");
        } else {
            $button.html("Loading...");
            $contact_form.find(':input').attr('disabled', false).val(null);
            
            $.get("/leads/" + contact_id + ".json", function(data) {
                $contact_form.find(":input").each(function(idx, el) {
                    var $input = $(el);
                    var name = $input.attr("name");
                    var match;
                    
                    if (name && (match = name.match(/\[(?:customer_attributes|contact_attributes)\]\[(.+)\]/))) {
                        var field = match[1];
                        $input.val(data.contact[field]);
                    }
                });
                $contact_form.addClass('styled-inner-form');
                $contact_form.show();
                $button.html("Hide contact details");
            }).fail(function(xhr) {
                // Re-disable the emptied inputs so a later deal Save can't overwrite the contact with blanks.
                $contact_form.find(':input').attr('disabled', true);
                $button.html("View/edit contact");
                showDealError(xhr, "Couldn't load the contact details — please try again.");
            });
        }
    }
  });
  $("form.edit_deal, form.new_deal").on("click", ".add-contact", function(event) {
    let selectedItem = document.querySelector('.customer .choices__item[aria-selected="true"]');
    var $contact_group = $(this).closest(".control-group.contact");
    var $select = $contact_group.find("[name$='[contact_id]']");

    var choicesInstance = $select[0] && $select[0]._choices;
    if (choicesInstance) { choicesInstance.removeActiveItems(); }
    $select.val('');
    $contact_group.find(".combobox").val('');
  });

  // [Quick Quote] shortcut: assign the special value 0 to the contact/cobuyer
  // picker so a dealer can run numbers without picking a real contact. (Quick
  // Quote isn't in the remote results, so we set it explicitly.)
  $("form.edit_deal, form.new_deal").on("click", ".quick-quote-contact", function(event) {
    event.preventDefault();
    var $select = $(this).closest(".control-group.contact").find("select[name$='[contact_id]']");
    var ci = $select[0] && $select[0]._choices;
    if (ci) {
      ci.setChoices([{ value: "0", label: "[Quick Quote]", selected: true }], "value", "label", false);
    } else {
      if ($select.find("option[value='0']").length === 0) {
        $select.append($("<option>", { value: "0", text: "[Quick Quote]" }));
      }
      $select.val("0");
    }
    $select.trigger("change");
  });

  // [Quick Quote] for the vehicle picker (value 0 is already in the list).
  $("form.edit_deal, form.new_deal").on("click", ".quick-quote-vehicle", function(event) {
    event.preventDefault();
    var $select = $("select[name='deal[vehicle_id]']");
    var ci = $select[0] && $select[0]._choices;
    if (ci) {
      ci.setChoiceByValue("0");
    } else {
      $select.val("0");
    }
    $select.trigger("change");
  });

  $("form.edit_deal, form.new_deal").on("click", ".save-and-add-contact", function(event) {
    var $self = $(this);
    var attr_name = $self.data('attr-name');
    var $contact_group = $self.closest(".control-group.contact");
    var $select = $contact_group.find("[name$='[contact_id]']");
    var contact_id = $select.val();
    var name = $select.attr("name").replace("[contact_id]", "[" + attr_name + "]");
    var params = $("form.edit_deal, form.new_deal").find("[name^='" + name + "']").serialize();
    var regex = new RegExp(encodeURIComponent(name), "g");
    var contact_params = params.replace(regex, "contact");
    var csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

    $.ajax({
      url: (contact_id ? "/leads/" + contact_id + ".json" : "/leads.json"),
      type: (contact_id ? "PUT" : "POST"),
      data: contact_params,
      headers: {
        'X-CSRF-Token': csrfToken
      },
      success: function(xhr) {
        var $contact_group = $self.closest(".control-group.contact");
        var $select = $contact_group.find("select[name$='[contact_id]']");

        var contactId = String(xhr.contact.id);
        var contactName = xhr.contact.name;

        // Add the freshly-created contact to the picker and select it. The
        // contact pickers are remote-search Choices instances that don't carry
        // the full list, so add the option through the Choices API.
        var choicesInstance = $select[0] && $select[0]._choices;
        if (choicesInstance) {
          choicesInstance.setChoices(
            [{ value: contactId, label: contactName, selected: true }],
            "value",
            "label",
            false
          );
          $select.trigger("change");
        } else {
          if ($select.find("option[value='" + contactId + "']").length === 0) {
            $select.append($("<option>", { value: contactId, text: contactName }));
          }
          $select.val(contactId).trigger("change");
        }

        $(".error_explanation, .alert").remove();

        $("form.edit_deal, form.new_deal").before(
          "<div class='alert alert-success'>Contact saved and assigned successfully</div>"
        );

        $contact_group.find(".contact-form").slideUp();
      },
      error: function(xhr) {
        var responseJSON = $.parseJSON(xhr.responseText);
        $(".error_explanation").remove();
        $(".alert").remove();
        $("form.edit_deal, form.new_deal").before("<div class='error_explanation'>" + responseJSON.error_explanation + "</div>");
        window.scrollTo(0, 0);
      }
    });

    event.preventDefault();
    event.stopPropagation();
    return false;
  });
  $('body').on("click", ".remove_deferred_down.red", function(e) {
    e.preventDefault();
    var $deferred_down = $(this).closest("li");
    $deferred_down.find('.calculate').val('0');
    $deferred_down.find('.destroy').val('1');
    $deferred_down.hide();
    deal.calculate();
  });

  $(document).ready(function() {
    $('#show_accessories_link').click(function(e) {
      e.preventDefault(); // Prevent default link behavior

      $('#deal_accessories_cost_wrapper').toggleClass('hidden');
      var linkText = $('#deal_accessories_cost_wrapper').hasClass('hidden') ? 'Show cost' : 'Hide cost';
      $(this).text(linkText);
      if (linkText === 'Hide cost') {
        $(this).removeClass('blue-text').addClass('red-text');
      } else {
        $(this).removeClass('red-text').addClass('blue-text');
      }
    });
    $('#show_cost_link').click(function(e) {
      e.preventDefault(); // Prevent default link behavior

      $('#gap_contract_cost_wrapper').toggleClass('hidden');
      var linkText = $('#gap_contract_cost_wrapper').hasClass('hidden') ? 'Show cost' : 'Hide cost';
      $(this).text(linkText);
      if (linkText === 'Hide cost') {
        $(this).removeClass('blue-text').addClass('red-text');
      } else {
        $(this).removeClass('red-text').addClass('blue-text');
      }
    });
  });

  // (Removed the old `#deal_inventory_vin` input handler that only flashed
  // "VIN is invalid, try again" without ever decoding — and bound to a single,
  // duplicated id so it never scoped to the right trade-in. Real per-row
  // auto-decode now lives in the trade-in VIN decode block below.)
  $("form.edit_deal, form.new_deal").on("click", ".edit-inventory .save-inventory", function(event) {
    var $form = $(this).closest("form");
    var name = "deal[vehicle_attributes]";

    $form.find("input.number, input.currency, input.currency_decimal").each(function() {
      var inputValue = $(this).val();
      if (!isNaN(inputValue)) {
          $(this).val(parseFloat(inputValue));
      }
    });
    var params = $form.find("[name^='" + name + "']").serialize();
    var regex = new RegExp(encodeURIComponent(name), "g");
    var inventory_params = params.replace(regex, "inventory");
    var csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
    $.ajax({
        url: "/inventory/" + $form.find("[name='deal[vehicle_id]']").val() + ".json",
        type: "PUT",
        data: inventory_params,
        headers: {
            'X-CSRF-Token': csrfToken
        },
        success: function(xhr) {
            $form.find(".edit-inventory-button").click();
            $(".error_explanation, .alert").remove();
            $form.before("<div class=\"alert alert-success\">Inventory successfully updated</div>");
            window.scrollTo(0, 0);
        },
        error: function(xhr) {
            var responseJSON = $.parseJSON(xhr.responseText);
            $(".error_explanation, .alert").remove();
            $form.before("<div class=\"error_explanation\">" + responseJSON.error_explanation + "</div>");
        }
    });
  });

  // NOTE: v2 wraps the form in `.v2-deal-form` (not `.deals`), so this delegated
  // handler must include it or the "Include lienholder" checkbox never reveals its
  // fields on the v2 OS deal form (Heiser #5159).
  $('.deals, .v2-deal-form, .inventory-purchasing').on('change', '.include-checkbox', function () {
    var targ = $(this);
    var fields = targ.closest('.field, .row').nextAll('.included-fields').first();
    var isChecked = targ.is(":checked");
    if (isChecked) {
      fields.show();
      // The lienholder vendor <select> is Choices.js-enhanced while its container is
      // display:none (include_lienholder defaults false). A Choices select initialized
      // hidden can leave the native <select>.value unsynced until interacted with — so
      // the chosen vendor wasn't in the first POST and the lienholder saved with a null
      // vendor_id (blank on the affidavit). Re-syncing the widget once it's visible
      // ensures the selection is reflected in the native select for submit. This is the
      // root cause of "lienholder doesn't show until you clear & re-add it".
      fields.find('select').each(function () {
        if (this._choices && typeof this._choices.getValue === 'function') {
          var val = this._choices.getValue(true);
          if (val != null && val !== '') { this.value = val; }
        }
      });
    } else {
      fields.find("input").not('[id$="account_id"]').val('');
      // Clear through the Choices instance when present so the widget and the native
      // <select> stay in sync (a bare select.val('') leaves the Choices UI showing the
      // old pick); fall back to clearing the native select otherwise.
      fields.find('select').each(function () {
        if (this._choices && typeof this._choices.removeActiveItems === 'function') {
          this._choices.removeActiveItems();
        }
        this.value = '';
      });
      fields.hide();
    }
  })

  $('#deal_lienholder_attributes_vendor_id').on('change', function() {
    var vendorId = $('#deal_lienholder_attributes_vendor_id').val();
    if (vendorId) {
      $.get('/api/vendors/' + vendorId + '.json', function(data) {
        $('#deal_lienholder_attributes_account_number').val(data.account_number);
      }).fail(function() {
        console.warn('Could not load lienholder account number for vendor ' + vendorId);
      });
    }
  });

  $(document).ready(function() {
    // Uncheck other checkboxes when a checkbox is checked
    $('.calculate.type_of_sale').on('change', function() {
        if ($(this).is(':checked')) {
            $('.calculate.type_of_sale').not(this).prop('checked', false);
        }
    });
    $('.calculate.finance_payments').on('change', function() {
        if ($(this).is(':checked')) {
            $('.calculate.finance_payments').not(this).prop('checked', false);
        }
    });
    $('.calculate.interest_computation').on('change', function() {
        if ($(this).is(':checked')) {
            $('.calculate.interest_computation').not(this).prop('checked', false);
        }
    });
    $('.calculate.deal_late_fees_type').on('change', function() {
        if ($(this).is(':checked')) {
            $('.calculate.deal_late_fees_type').not(this).prop('checked', false);
        }
    });

    $('.adjustment_option_box').on('change', function() {
        $('.adjustment_option_box').not(this).prop('checked', false);
    });

    $('.adjustment_target_box').on('change', function() {
      $('.adjustment_target_box').not(this).prop('checked', false);
    });

    $(".pricing-adjustment-active .target-options [name='adjustment_target']").on('change', function(event) {
      $(".pricing-adjustment-active .target-options [name$='_adjustment']").prop('disabled', true);
      
      var option = $(".pricing-adjustment-active .target-options [name='adjustment_target']:checked").val();
      $(".pricing-adjustment-active .target-options [name='" + option + "_adjustment']").prop('disabled', false);
      
      if ($("#adjustment_target_amount_financed").is(':checked')) {
          $(".pricing-adjustment-active .adjustment-options #adjustment_option_interest_rate").prop('disabled', true);
      } else {
          $(".pricing-adjustment-active .adjustment-options #adjustment_option_interest_rate").prop('disabled', false);
      }
    });
    const dealType = function () {
        const checkedCheckbox = $("input[name='deal[type_of_sale]']:checkbox:checked");
        if (checkedCheckbox.length > 0) {
            return checkedCheckbox.val();
        } else {
            return null; // No checkbox is checked
        }
    };

    $('[name="deal[type_of_sale]"]').on('change', function (event) {
      toggle_type_of_sale($(this).val(), true);
    });

    if ($('[name="deal[type_of_sale]"]').length > 0) {
      toggle_type_of_sale();
      updateSaleInformationFields();
    }

    // Set a value on a possibly-Choices-backed <select> so BOTH the native value
    // and the visible Choices widget update. #deal_frequency is a js-choices select
    // (data-choices-target="choices"); a bare $.val() would leave the widget showing
    // the old label and can save the stale value — the recurring Choices .val() bug.
    function setSelectValue(selector, value) {
      var el = document.querySelector(selector);
      if (!el) return;
      if (el._choices) {
        el._choices.setChoiceByValue(String(value));
      } else {
        $(el).val(value);
      }
    }

    function toggle_type_of_sale(value, force_values) {
      if (!value) {
        value = $('[name="deal[type_of_sale]"]:checked').val();
      }

      if (value === 'cash' || value === 'wholesale') {
        if (force_values) {
          $('#deal_no_of_payments').val(1);
          $('#deal_interest_rate').val(0);
          setSelectValue('#deal_frequency', '0');
          // interest_method is now a set of radios (name="deal[interest_method]");
          // reset to the simple_interest default for cash/wholesale.
          document.querySelectorAll('input[name="deal[interest_method]"]').forEach(function(r) {
            r.checked = (r.value === 'simple_interest');
          });
        }
        $('#bhph_fields').hide();
        $('#outside_financing_fields').hide();
      } else if (value === 'bhph') {
        $('#bhph_fields').show();
        $('#outside_financing_fields').hide();
        if (force_values) {
          setSelectValue('#deal_frequency', '12');
        }
      } else if (value === 'outside_financing') {
        $('#bhph_fields').hide();
        $('#outside_financing_fields').show();
        if (force_values) {
          setSelectValue('#deal_frequency', '12');
        }
      }
    }

    function updateSaleInformationFields() {
      const typeOfSale = dealType();
      console.log('typeOfSale:', typeOfSale);
      switch (typeOfSale) {
          case 'bhph':
          case 'outside_financing':
              $('.financial_terms_container').removeClass('hidden');
              $('.cash-deferred-down-container').removeClass('hidden');
              if (window.moment && $('#deal_first_payment').val() === '') {
                  $('#deal_first_payment').val(moment().add('months', 1).format('L'));
              }
              break;
          case 'cash':
              $('.financial_terms_container').addClass('hidden');
              $('.cash-deferred-down-container').addClass('hidden');
              break;
          case 'wholesale':
              // A wholesale (dealer-to-dealer) deal computes NO sales tax and excludes
              // consumer fees from the total — but the SERVER already enforces that
              // (Deal#taxable_sale returns 0 → total_tax is 0 regardless of the stored
              // rates, and Deal#grand_total for wholesale omits doc prep / license / title
              // / lien / transfer). Zeroing the fee/tax INPUTS here was pure data loss:
              // it silently and IRREVERSIBLY wiped the dealer's entered doc prep / title /
              // license / tax rates / custom fees (toggling back to cash did NOT restore
              // them) and, on Save, persisted $0 across the recap. Keep the values; just
              // hide the financing terms (like a cash deal).
              $('.financial_terms_container').addClass('hidden');
              $('.cash-deferred-down-container').addClass('hidden');
              break;
          default:
              // Handle other cases or no selection
              break;
        }
    };

    // Event listener for checkbox change
    $("input[name='deal[type_of_sale]']:checkbox").on('change', function () {
        updateSaleInformationFields();
    });
  });
  
  $(document).ready(function() {
  // Activate button click handler
    $(".pricing-adjustment-inactive button.activate").on("click", function(event) {
      event.preventDefault();  // Prevent form submission
      event.stopPropagation(); // Stop event from bubbling up

      var input = $("#amount_financed_adjustment");
      $(".pricing-adjustment-active").show();   // Show the active pricing adjustment section
      $(".pricing-adjustment-inactive").hide(); // Hide the inactive pricing adjustment section
      input.val(formatDealMoney(input.data("original-value")));  // Format like the sibling Payment/Total fields ($23,112.94), not the raw number

      // Optionally, you can call formatCurrency() here if needed
      return false;  // Prevent default form action or navigation
    });

    // Deactivate button click handler
    $(".pricing-adjustment-active button.deactivate").on("click", function(event) {
      event.preventDefault();  // Prevent form submission
      event.stopPropagation(); // Stop event from bubbling up

      var input = $("#amount_financed_adjustment");
      $(".pricing-adjustment-active").hide();   // Hide the active pricing adjustment section
      $(".pricing-adjustment-inactive").show(); // Show the inactive pricing adjustment section
      input.val(formatDealMoney(input.data("original-value")));  // Reset to original value, formatted as currency ($23,112.94)

      return false;  // Prevent default form action or navigation
    });
  });

  class Deal {
    constructor(el) {
      this.deal = $(el);
      this.deal.on('change', '[name="deal[type_of_sale]"]', this.update_sale_information_fields.bind(this));
      this.deal.on('change', '.deal_late_fees_type', this.updateLateFees.bind(this));

      this.init();
      this.deferred_down_5_limit();
    }

    init() {
      this.update_sale_information_fields();
      this.updateLateFees();
    }

    updateLateFees() {
      const late_fees_type = this.deal.find('.deal_late_fees_type:radio:checked').val();
      const late_fees = $('#deal_late_fees');

      if (late_fees_type === 'percentage') {
        late_fees.removeClass('currency_decimal').addClass('decimal');
      } else {
        late_fees.removeClass('decimal').addClass('currency_decimal');
      }

      late_fees.trigger('blur');
    }

    deferred_down_5_limit() {
      this.deal.on('click', '#list-deferred_downs a.add_child', (e) => {
        if ($('#list-deferred_downs li:visible').length >= 5) {
          alert('Too many deferred downs');
          e.stopImmediatePropagation();
          return false;
        }
      });
    }

    deal_type() {
      return this.deal.find('input[name="deal[type_of_sale]"]:checked').val();
    }

    update_sale_information_fields() {
      switch (this.deal_type()) {
        case 'bhph':
        case 'outside_financing':
          this.deal.find('.financial_terms_container').removeClass('hidden');
          this.deal.find('.cash-deferred-down-container').removeClass('hidden');

          if (window.moment && this.deal.find("#deal_first_payment").val() === '') {
            this.deal.find("#deal_first_payment").val(moment().add('months', 1).format('L'));
          }
          break;
        case 'cash':
          // Retail cash sale: hide the financing terms, but KEEP the fees/taxes —
          // a cash deal still has doc prep, tax, etc. (Zeroing them here is what
          // wiped fees on every recalculation once calculate was re-enabled.)
          this.deal.find('.financial_terms_container').addClass('hidden');
          this.deal.find('.cash-deferred-down-container').addClass('hidden');
          break;
        case 'wholesale':
          // KEEP the fees/taxes — the server already returns 0 tax and omits consumer
          // fees for a wholesale deal (see the standalone updateSaleInformationFields
          // note), so zeroing the inputs here only caused silent, irreversible data loss
          // on every recalc/init. Just hide the financing terms.
          this.deal.find('.financial_terms_container').addClass('hidden');
          this.deal.find('.cash-deferred-down-container').addClass('hidden');
          break;
        default:
          break;
      }
    }

    calculate() {
      const el = $(deal_form_selector);
      const url = el.attr("id").match(/\d+$/) ? "/deals/" + el.attr("id").match(/\d+$/)[0] + "/calculate.json" : "/deals/calculate.json";
      var csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
      el.ajaxForm({
        url: url,
        dataType: 'json',
        type: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken
        },
        success: (data, status, form) => {

          // Resilient to BOTH response shapes: a correctly-configured backend returns the deal
          // fields flat ({cash_price_cents: …}); a backend with include_root_in_json enabled
          // (e.g. a mis-configured Rails upgrade) nests them under a "deal" root while custom
          // fees stay top-level ({deal: {cash_price_cents: …}, lender_fee: …}). Without this,
          // every read is undefined → dealFormatCurrency(NaN) → "$0.00" blanks every field.
          const deal_data = (data && typeof data.deal === 'object' && data.deal !== null)
            ? Object.assign({}, data, data.deal)
            : data;
          const highlightUpdatedField = (element, newValue) => {
            const $element = $(element);
            $element.html(newValue);
          };
          $("#sidebar .summary .summary-field").each(function() {
            const attribute = $(this).attr("data-deal-field");
            const attribute_cents = attribute + '_cents';

            if (attribute in deal_data || attribute_cents in deal_data) {
              if (deal_data[attribute] && typeof deal_data[attribute] === 'object' ) {
                const value = deal_data[attribute].cents / 100;
                highlightUpdatedField($(this).find(".summary-data"), dealFormatCurrency(value));
              } else {
                let value = deal_data[attribute] || (deal_data[attribute_cents] / 100);

                if (deal_data[attribute] && attribute === "no_of_payments") {
                  let no_of_payments = Math.ceil(deal_data.no_of_payments);

                  if (deal_data.final_payment_amount_cents && deal_data.final_payment_amount_cents !== deal_data.payment_cents) {
                    no_of_payments += 1;
                  }
                  highlightUpdatedField($(this).find(".summary-data"), `${no_of_payments} (${deal_data.frequency_type})`);
                } else {
                  // Render the Total / amount rows ONLY through dealFormatCurrency so they
                  // always show 2 decimals (5,505.50). The previous code first wrote the raw
                  // number (5505.5) into the cell, which could be left visible — banks reject
                  // a contract that drops the trailing-zero cent.
                  let numericValue = (typeof value === 'string')
                    ? parseFloat(value.replace(/[^\d.-]/g, ''))
                    : value;
                  highlightUpdatedField($(this).find(".summary-data"), dealFormatCurrency(numericValue));
                }
              }
            }
          });

          if ($("#deal_calculate_financing_by_no_of_payments_true").is(":checked")) {
            $("#deal_payment").val(deal_data.payment_cents / 100);
            $("#sidebar .summary-field.final_payment_amount").hide();
          } else { 
            $("#sidebar .summary-field.final_payment_amount").show();
            $("#deal_no_of_payments").val(Math.ceil(deal_data.no_of_payments));
          }

          // Cash & wholesale deals have no payment schedule — hide the payment summary rows.
          var dealNoPayments = ['cash', 'wholesale'].indexOf($('input[name="deal[type_of_sale]"]:checked').val()) !== -1;
          var $dealPaymentRows = $("#sidebar .summary-field.payment, #sidebar .summary-field.no_of_payments, #sidebar .summary-field.finance_charge, #sidebar .summary-field.total_payments");
          if (dealNoPayments) {
            $dealPaymentRows.hide();
            $("#sidebar .summary-field.final_payment_amount").hide();
          } else {
            $dealPaymentRows.show();
          }

          $("#deal_cash_price").val(dealFormatCurrency(deal_data.cash_price_cents / 100));
          $("#deal_cash_down").val(dealFormatCurrency(deal_data.cash_down_cents / 100));
          // $("#deal_deferred_down").val(dealFormatCurrency(deal_data.deferred_down / 100);
          if (deal_data.interest_rate != null && deal_data.interest_rate !== '') {
            const rate = parseFloat(deal_data.interest_rate);
            if (!isNaN(rate)) {
              $("#deal_interest_rate").val(rate.toFixed(6));
            }
          }

          // Refresh the pricing-adjustment target fields' baseline from the recalc — but NEVER
          // overwrite the value the dealer is TYPING into the currently-selected target while the
          // adjustment panel is open. A background recalc (very common on a NEW deal whose first
          // calculate is still settling, or any in-flight `.calculate` change) otherwise clobbered
          // e.g. #amount_financed_adjustment back to the current computed amount — so "Make pricing
          // adjustment" then solved for the UNCHANGED number and the Summary never moved. This was
          // the "pricing adjustment / override doesn't update on a new deal" report. data-original-
          // value is always kept fresh (activate / Cancel read it); only the visible value of the
          // actively-selected target is preserved.
          const activeAdjustTarget = $(".pricing-adjustment-active:visible input[name='adjustment_target']:checked").val();
          const setAdjustField = (id, targetName, displayValue, originalValue) => {
            const $f = $(id);
            $f.data('original-value', originalValue);
            if (activeAdjustTarget === targetName) return; // preserve the dealer's typed target
            $f.val(displayValue);
          };
          const amountFinancedCents = (deal_data.amount_financed && deal_data.amount_financed.cents != null) ? deal_data.amount_financed.cents : 0;
          setAdjustField("#amount_financed_adjustment", "amount_financed", dealFormatCurrency(amountFinancedCents / 100), amountFinancedCents / 100);
          setAdjustField("#total_payments_adjustment", "total_payments", dealFormatCurrency(deal_data.total_payments_cents / 100), deal_data.total_payments_cents / 100);
          setAdjustField("#payment_adjustment", "payment", dealFormatCurrency(deal_data.payment_cents / 100), deal_data.payment_cents / 100);
          setAdjustField("#no_of_payments_adjustment", "no_of_payments", deal_data.no_of_payments, deal_data.no_of_payments);

          $('#deal_receivable_amount').val(dealFormatCurrency(deal_data.receivable_amount_cents / 100));
          $('#deal_reserve_amount').val(dealFormatCurrency(deal_data.reserve_amount_cents / 100));
          $('#deal_total_amount_to_receive_from_lien_holder').val(dealFormatCurrency(deal_data.total_amount_to_receive_from_lien_holder / 100));

          $('.summary').removeClass('loading');
        },
        error: (xhr) => {
          // The recalc failed server-side. Without this the .summary kept its .loading class
          // forever — a frozen spinner with no message (the exact "doesn't work" report). Release
          // the spinner and tell the dealer what to check.
          showDealError(xhr, 'Couldn’t recalculate the deal — check the figures (a trade-in may be missing its allowance) and try again.');
        }
      });

      const form_method = el.find("input[name='_method']"); // scope to THE deal form being submitted — an unscoped page-level _method (e.g. the v2 header logout button_to's delete) is otherwise grabbed first, breaking the patch<->post recalc swap
      if (form_method && form_method.attr("value") === "patch") {
        form_method.attr("value", "post");
      }
      el.submit();
      format_number();
      el.ajaxFormUnbind();
      form_method.attr("value", "patch") 
      if (form_method && form_method.attr("value") === "post"){
        form_method.attr("value", "patch");
      }
    }
  }

  var deal_form_selector = ".new_deal, .edit_deal"

  var deal = new Deal(deal_form_selector)

  // Bind "Make pricing adjustment" via EVENT DELEGATION on document. deal.js runs on
  // EVERY page (turbo:load), but the button only exists on the deal form — the old code
  // did a one-shot querySelector at ready-time and console.error'd "Make adjustment
  // button not found" on every non-deal page. That app-wide error read like the feature
  // was broken (and was fragile: any v2 re-render/relocation of the button after ready
  // would leave it unbound). Delegation binds regardless of when/whether the button is in
  // the DOM, never fires the spurious error, and can't regress on markup timing changes.
  // The namespaced .off() keeps repeated turbo:load passes from stacking duplicate handlers.
  $(document).off("click.pricingAdjust").on("click.pricingAdjust", ".pricing-adjustment-active button.make-adjustment", function(event) {
    // <button> with no type = submit; without preventDefault the form submits (calculate()
    // is async + unbinds ajaxForm) → the un-adjusted deal saves and redirects to overview
    // before the adjustment applies. Prevent the submit; let the AJAX recalc do the work.
    event.preventDefault();
    event.stopPropagation();
    var adjustPriceInput = document.querySelector(".pricing-adjustment-active input[name='adjust_price']");
    if (!adjustPriceInput) {
      console.error("Input field for adjust_price not found");
      return;
    }
    adjustPriceInput.value = "true"; // server runs Deal#pricing_adjustment when adjust_price is set
    if (typeof deal !== "undefined" && typeof deal.calculate === "function") {
      deal.calculate();
    } else {
      console.error("deal.calculate is not a valid function");
    }
    adjustPriceInput.value = null;
  });

  function dealFormatCurrency(value) {
    if (!isNaN(value)) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(value);
    } else {
      return '$0.00'; // or some default value
    }
  }



  function format_number() {
   $(".currency").each(function() {
      const value = parseFloat($(this).val());
      if (!isNaN(value)) {
        // Always show 2 decimals — banks require full cash format (5,505.50, not 5,505.5
        // or 5,506). toFixed(0) dropped the cents entirely.
        const formattedValue = '$' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        $(this).val(formattedValue);
      }
    });

    $(".currency_decimal").each(function() {
      const value = parseFloat($(this).val());
      if (!isNaN(value)) {
        const formattedValue = '$' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        $(this).val(formattedValue);
      }
    });

    $(".decimal").each(function() {
      const value = parseFloat($(this).val());
      if (!isNaN(value)) {
        const formattedValue = value.toFixed(6); // Six decimal places
        $(this).val(formattedValue);
      }
    });

    $(".number").each(function() {
      const value = parseFloat($(this).val());
      if (!isNaN(value)) {
        const formattedValue = value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        $(this).val(formattedValue);
      }
    });
  }

  // APR / rate fields (.decimal) must stay plain numbers — never $ — or Rails saves 0.
  function normalizeDealDecimalFields($scope) {
      const $fields = $scope ? $scope.find('input.decimal') : $('form.new_deal, form.edit_deal input.decimal');
      $fields.each(function () {
        const raw = $(this).val();
        if (raw === '' || raw == null) return;
        const num = parseFloat(String(raw).replace(/[^0-9.-]/g, ''));
        if (!isNaN(num)) {
          $(this).val(num.toFixed(6));
        }
      });
    }
    // ... used on calculate and on form submit
  const changeDecimalFieldsOnSubmit = () => {
    normalizeDealDecimalFields();
  };

  const calculate_financing = () => {
    const deal = new Deal(deal_form_selector);
    changeDecimalFieldsOnSubmit();
    $('.summary').addClass('loading');
    deal.calculate();
  };

  $('form.new_deal, form.edit_deal').off('submit.dealNormalize').on('submit.dealNormalize', function () {
    const $form = $(this);
    normalizeDealDecimalFields($form);
    $form.find('input.number, input.currency, input.currency_decimal').toNumber();
  });

  $("#deal").on("change", ".calculate", () => {
    calculate_financing();
  });
})
$(document).ready(function() {
  // Trade-in forms are visible by default (so a just-added trade-in shows
  // immediately). Clicking a trade-in header collapses/expands that one.
  // (Previously `$('.inset.trade-ins').toggle()` hid them on load — which also
  // hid the contents of the hidden add-template, so every cloned trade-in came
  // in hidden and looked like "Add a trade-in" did nothing.)
  $(document).on('click', '.trade-in-toggle[data-child-trade]', function() {
    var targetId = $(this).data('child-trade');
    $('.inset.trade-ins#child-trade-' + targetId).toggle();
  });

  // ---- Trade-in VIN decode --------------------------------------------------
  // Decodes a trade-in's VIN into that trade-in card's vehicle fields, both
  // automatically (as soon as a full 17-char VIN is entered) and via the manual
  // "Decode" link. Delegated on document so it also works for trade-ins added
  // after page load, and everything is scoped to the triggering `.accordion-group`
  // card so multiple trade-ins on one deal never cross-populate.
  // inventory.js's decoder targets the single-vehicle inventory page's
  // #inventory_vin (absent on a deal), so trade-in decode is wired up here.
  // NOTE: the trade-in Decode link uses class `.trade-in-vin-decode` (NOT
  // `.vin_lookup_trigger`) precisely so inventory.js's single-vehicle handler —
  // which reads #inventory_vin and throws on the deal page — never binds to it.
  // `.v2-deal-form` covers the v2 OS deal form (container is `.v2-deal-form`,
  // not `.deals`) — Heiser #5159.
  var TRADE_VIN_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/i;

  function tradeInField($card, field) {
    return $card.find('[name$="[inventory_attributes][' + field + ']"]').first();
  }

  // Set a <select>'s value so an attached Choices.js widget also reflects it — a
  // bare .val() only updates the hidden native select, so the visible widget (and
  // the value that gets saved) stayed blank. This is the recurring Choices bug that
  // left the decoded vehicle_type / body_type / doors / transmission / fuel_type
  // saving blank on trade-ins. Adds the value as a choice first when it isn't
  // already present (body_type options depend on vehicle_type and may not include
  // the decoded value yet).
  function setTradeInSelect($field, value) {
    if ($field.length === 0 || value == null || value === '') return;
    value = String(value);
    var el = $field.get(0);
    var choices = el && el._choices;
    var present = $field.find('option').filter(function () { return $(this).val() === value; }).length > 0;
    if (choices) {
      if (!present) choices.setChoices([{ value: value, label: value }], 'value', 'label', false);
      choices.setChoiceByValue(value);
    } else {
      if (!present) $field.append($('<option>').val(value).text(value));
      $field.val(value).trigger('change');
    }
  }

  function tradeInNotice($card, message, delay) {
    var $n = $card.find('.load_notice').first();
    if ($n.length === 0) return;
    $n.stop(true, true).html(message).show();
    if (delay) $n.delay(delay).fadeOut(1000);
  }

  function runTradeInVinDecode($card) {
    var vin = ($card.find('input.vin').first().val() || '').trim().toUpperCase();
    if (!TRADE_VIN_REGEX.test(vin)) {
      tradeInNotice($card, 'Enter a valid 17-digit VIN to decode', 4000);
      return;
    }
    if ($card.data('decodingVin') === vin) return; // already decoded / in-flight for this VIN
    $card.data('decodingVin', vin);
    tradeInNotice($card, 'Decoding…', 0);
    $.getJSON('/inventory/' + encodeURIComponent(vin) + '/vin_lookup.json')
      .done(function (data) {
        var inv = (data && data.inventory) || {};
        // Plain text fields (stock_number intentionally left alone — it is auto-filled).
        ['year', 'make', 'model', 'trim_level', 'engine', 'exterior_color', 'interior_color'].forEach(function (f) {
          if (inv[f] == null || inv[f] === '') return;
          tradeInField($card, f).val(inv[f]).removeClass('is-invalid');
        });
        // Now that we've populated, clear any server-rendered per-field error markers.
        $card.find('.is-invalid').removeClass('is-invalid');
        $card.find('.invalid-feedback').remove();
        // Independent Choices selects.
        ['doors', 'transmission', 'fuel_type', 'vehicle_type'].forEach(function (f) {
          setTradeInSelect(tradeInField($card, f), inv[f]);
        });
        // body_type's option list depends on vehicle_type; setting vehicle_type above
        // triggers inventory.js's async reload of the body_type list, so apply the
        // decoded body_type after that settles (setTradeInSelect re-adds it if the
        // reload replaced the option list).
        if (inv.body_type) {
          window.setTimeout(function () { setTradeInSelect(tradeInField($card, 'body_type'), inv.body_type); }, 700);
        }
        var title = [inv.year, inv.make, inv.model].filter(Boolean).join(' ');
        if (title) $card.find('.trade-in-name').first().text('Trade-in ' + title);
        tradeInNotice($card, 'Decoded ✓', 3000);
      })
      .fail(function () {
        $card.data('decodingVin', ''); // allow a retry
        tradeInNotice($card, 'Could not decode VIN — please verify it', 6000);
      });
  }

  // Manual "Decode" link.
  $(document).on('click', '.deals .trade-in-vin-decode, .v2-deal-form .trade-in-vin-decode', function (e) {
    e.preventDefault();
    runTradeInVinDecode($(this).closest('.accordion-group.fields'));
  });

  // Auto-decode as soon as a full 17-char VIN is typed/pasted into a trade-in VIN.
  $(document).on('input', '.deals .trade-ins input.vin, .v2-deal-form .trade-ins input.vin', function () {
    var $field = $(this);
    var cleaned = ($field.val() || '').replace(/\s/g, '');
    if ($field.val() !== cleaned) $field.val(cleaned);
    var $card = $field.closest('.accordion-group.fields');
    if (TRADE_VIN_REGEX.test(cleaned)) {
      runTradeInVinDecode($card);
    } else {
      $card.data('decodingVin', ''); // reset so re-completing the VIN re-decodes
    }
  });

  // Format currency fields (e.g. trade-in ACV) as $#,###.## on blur. The bulk
  // formatter only runs on load/calculate, so fields in dynamically-added
  // trade-ins weren't being formatted as the user typed.
  $(document).on('blur', '.deals input.currency_decimal, .v2-deal-form input.currency_decimal', function() {
    var n = parseFloat(($(this).val() || '').replace(/[^0-9.-]/g, ''));
    if (!isNaN(n)) { $(this).val('$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')); }
  });

});


$(document).on('change', '.commission_type', function () {
  // Find the closest parent form container for the current checkbox
  var $currentForm = $(this).closest('.commission-form');

  // Uncheck all other checkboxes within this specific form
  $currentForm.find('.commission_type').not(this).prop('checked', false);
});


$(document).ready(function() {
  // Find the parent element with class 'vendor' and then find its child element with class 'choices'
  var vendorChoices = $('.vendor').find('.choices');
  vendorChoices.css('width', '75%');
  $('.inner-form-vendor.vendor-gapcontract').each(function() {
      $(this).find('fieldset').css('background-color', 'white');
      $(this).find('.card-body').css('background-color', 'white');
  });
  $('.inner-form-vendor.vendor-insurer').each(function() {
      $(this).find('fieldset').css('background-color', 'white');
      $(this).find('.card-body').css('background-color', 'white');
  });
});

$.fn.toNumber = function() {
  return this.each(function() {
    var value = $(this).val();
    if (value) {
      var numberValue = parseFloat(value.replace(/[^0-9.]/g, ''));
      if (isNaN(numberValue)) { return; }
      // Currency fields must keep BOTH cents — banks reject a contract that reads
      // "5505.5" instead of "5505.50". parseFloat() alone drops the trailing zero
      // (parseFloat("5505.50") === 5505.5), and this runs on submit, so it was the
      // last thing to touch the input and the value the dealer saw on reload.
      // Rails parses "5505.50" fine, so emit fixed 2-decimals for money inputs.
      var isCurrency = $(this).hasClass('currency') || $(this).hasClass('currency_decimal');
      $(this).val(isCurrency ? numberValue.toFixed(2) : numberValue);
    }
  });
};

$(".deals, .v2-deal-form").on("click", ".save-trade-in", function(event) {
  var $el = $(this);
  var dealId = $el.data("deal-id");
  var csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
  if (dealId) {
    // Use find instead of siblings to correctly locate the inputs
    var $input = $el.closest(".inventory_fields").find("[name^='deal[trade_ins_attributes]']");
    
    // Check if $input is not found or if name attribute is undefined
    if ($input.length === 0 || !$input.attr("name")) {
      console.error("Input with name starting 'deal[trade_ins_attributes]' not found.");
      return false;
    }
    
    var idx = $input.attr("name").match(/\[\d+\]/)[0];
    var name = "deal[trade_ins_attributes]" + idx;
    var $form = $("form.edit_deal");
    $form.find("input.number, input.currency, input.currency_decimal").toNumber();
    var params = $form.find("[name^='" + name + "']").serialize();
    var tradeInId = $el.data('trade-in-id');
    var child_trade_id = $el.data("child-trade");
    var requestType, url;
    if ($el.data('trade-in-id')) {
      requestType = 'PUT';
      url = "/deals/" + dealId + "/trade_ins/" + tradeInId;
    } else {
      requestType = 'POST';
      url = "/deals/" + dealId + "/trade_ins";
    }
    $.ajax({
      url: url,
      type: requestType,
      headers: {
        'X-CSRF-Token': csrfToken
      },
      data: params + "&child_block=" + child_trade_id,
      success: function() {
        // Only collapse the card AFTER the server confirms the save. Previously the collapse ran
        // unconditionally (fire-and-forget), so a rejected/blank trade LOOKED saved — the literal
        // "doesn't save trade-in information" report.
        $(".error_explanation, .alert").remove();
        $("form.edit_deal, form.new_deal").first().before("<div class='alert alert-success'>Trade-in saved and assigned to the deal</div>");
        $el.closest(".accordion-body").collapse("hide");
        if (typeof deal !== 'undefined' && deal.calculate) { deal.calculate(); }
      },
      error: function(xhr) {
        // Keep the card OPEN so the dealer can fix it, and say what's wrong.
        showDealError(xhr, "Couldn’t save the trade-in — check the vehicle details and trade allowance, then try again.");
      }
    });
  } else {
    $el.closest(".accordion-body").collapse("hide"); // no deal id yet (new deal) — trade saves with the deal on submit
  }
  return false;
});


  // Remove trade-in
$(".deals, .v2-deal-form").on("click", ".remove-trade-in", function(event) {
  event.preventDefault();
  var $el = $(this);
  $(".error_explanation").remove();
  $(".alert-success").remove();

  var accordionGroup = $el.closest(".accordion-group");
  // Use the persisted trade-in id as the signal (data-new renders blank for new
  // records, which previously made this delete the adjacent trade-in card).
  var tradeId = $el.data('trade-in-id');
  if (tradeId) {
    var dealId = $el.data('deal-id');
    var csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
    // Only the trailing hidden id field, never a neighbouring trade-in card.
    var $next = accordionGroup.next();
    if ($next.is('input[type="hidden"]')) { $next.remove(); }
    $.ajax({
      url: "/deals/" + dealId + "/trade_ins/" + tradeId,
      type: 'DELETE',
      headers: { 'X-CSRF-Token': csrfToken },
      dataType: 'json',
      success: function() {
        // Remove the card only AFTER the server confirms the delete — otherwise the card vanished
        // from the UI but the trade-in persisted and reappeared on reload.
        accordionGroup.remove();
        var $acc = $("#trade-ins-accordion");
        if ($acc.length) { window.scrollTo(0, $acc.offset().top); }
        $('form.edit_deal, form.new_deal').first().before('<div class="alert alert-success">Trade-in successfully removed</div>');
        if (typeof deal !== 'undefined' && deal.calculate) { deal.calculate(); }
      },
      error: function(xhr) {
        showDealError(xhr, "Couldn’t remove the trade-in — please try again.");
      }
    });
  } else {
    // New/unsaved trade-in: nothing server-side to delete, just drop the DOM.
    accordionGroup.remove();
    var $acc = $("#trade-ins-accordion");
    if ($acc.length) { window.scrollTo(0, $acc.offset().top); }
  }
});

// "Save forms" was the only forms button with NO explicit handler — it relied on the
// native submit of its <input type=submit>, while .print-forms / .email-forms drive the
// save through $form.submit() (the programmatic HTMLFormElement.submit(), which fires no
// submit event). The two handler-driven buttons work; the plain native one was reported
// as doing nothing. Give Save forms the same proven $form.submit() path so it no longer
// depends on native submission. submit_type stays "" → the controller's plain-save (else)
// branch (deals_controller#update). Also mirror the paid-form confirmation the others do.
$("form.edit_deal .save-forms").on("click", function(event) {
  event.preventDefault();
  var $form = $(this).parents("form");

  if ($form.find("[data-paid-form=true]").is(":checked") && PAID_FORMS_ENABLED !== true) {
      confirmPaidForms();
      return false;
  }

  $form.find("input[name=\"submit_type\"]").val("");
  $form.find(".save-forms, .print-forms, .email-forms").prop("disabled", true).addClass("disabled");
  $form.find(".save-forms").val("Saving...");
  $form.submit();
});

$("form.edit_deal .print-forms").on("click", function(event) {
  var $form = $(this).parents("form");

  if ($form.find("[data-paid-form=true]").is(":checked") && PAID_FORMS_ENABLED !== true) {
      confirmPaidForms();
      return false;
  } else {
      $form.find("input[name=\"submit_type\"]").val("print");

      // Set the print_token cookie using native JavaScript
      document.cookie = "print_token=" + $form.find("input[name=\"print_token\"]").val() + "; path=/";

      // Open the target tab NOW, synchronously in the click (a user gesture), so the
      // browser doesn't popup-block it. The combined PDF is fetched into this same
      // named tab AFTER the print-save reload (see the print_token handler below), so
      // the dealer keeps their deal open in the current tab. Named tabs survive the
      // opener's reload, so window.open(url, 'ml_forms_print') then reuses this one.
      var printWin = window.open("about:blank", "ml_forms_print");
      if (printWin) {
        try { printWin.document.write("<title>Preparing forms…</title><p style='font:16px system-ui;padding:24px'>Preparing your forms for printing…</p>"); } catch (e) {}
      }

      $form.find(".save-forms, .print-forms, .email-forms").prop("disabled", true).addClass("disabled");
      $form.find(".print-forms").html('<span class="deal-forms-spinner"></span>Generating…');
      $form.submit();
  }
});

// Per-form "Print" link (deals/forms/_status.html.haml) loading feedback (Fix 2). The link
// opens the single-form PDF in a NEW tab (target=_blank); a slow S3-backed generation used to
// give no feedback so it looked broken. Show a spinner + "Generating…" immediately, then restore
// when the dealer returns to this tab (window focus) or after a safety timeout — we can't observe
// the new tab's own load. Delegated on body so it also covers forms inserted later via AJAX.
$("body").on("click", "a.js-deal-form-print", function () {
  var $link = $(this);
  if ($link.hasClass("is-printing")) { return; }
  var original = $link.html();
  $link.addClass("is-printing").html('<span class="deal-forms-spinner"></span>Generating…');
  var timer;
  var restore = function () {
    $link.removeClass("is-printing").html(original);
    $(window).off("focus.dealFormPrint", restore);
    clearTimeout(timer);
  };
  timer = setTimeout(restore, 12000);
  $(window).on("focus.dealFormPrint", restore);
});
$(document).ready(function() {
  var printTokenCookie = document.cookie.replace(/(?:(?:^|.*;\s*)print_token\s*=\s*([^;]*).*$)|^.*$/, "$1");
  var printToken = parseInt(printTokenCookie, 10);

  if (!isNaN(printToken)) {
    document.cookie = "print_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"; // Remove print_token cookie

    var form = $("form.edit_deal");

    // Auto-fire the combined-PDF download after a print-save reload. This used to
    // be wrapped in a .print-forms click handler, so it needed a SECOND click —
    // with Turbo Drive off nothing re-triggered it, and the page just sat at
    // "Preparing forms for printing". The print_token cookie is set only on a
    // print-forms click and is removed above, so this runs exactly once.
    if (form.length) {
        form.find(".save-forms, .print-forms, .email-forms").prop("disabled", true).addClass("disabled");
        form.find(".print-forms").html('<span class="deal-forms-spinner"></span>Generating…');

        var pdfDownloadToken = "" + printToken;
        var intervalId = setInterval(function() {
            var pdfDownloadTokenCookie = document.cookie.replace(/(?:(?:^|.*;\s*)pdf_download_token\s*=\s*([^;]*).*$)|^.*$/, "$1");
            if (pdfDownloadTokenCookie === pdfDownloadToken) {
                form.find(".save-forms, .print-forms, .email-forms").prop("disabled", false).removeClass("disabled");
                form.find(".print-forms").html("Save forms & print all");
                clearInterval(intervalId);
            }
        }, 100);

        // Load the combined PDF into the tab opened during the print-forms click
        // (named "ml_forms_print"), so it opens in a NEW tab and the deal page stays
        // put. Targeting an EXISTING named tab isn't popup-blocked; fall back to a
        // same-tab navigation only if that tab is gone (e.g. dealer closed it).
        var pdfUrl = form.attr("action") + "/forms/print_all.pdf?pdf_download_token=" + pdfDownloadToken;
        var printWin = window.open(pdfUrl, "ml_forms_print");
        if (!printWin) { window.location.href = pdfUrl; }
    }
  }
});
$('.deal-add-forms').on('click', function (e) {
  var $button = $(this), form_ids;

  form_ids = $('input.add-additional-form-checkbox:checked').map(function () {
      return parseInt($(this).data('form-id'), 10);
  });

  var csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  $.post('/deals/' + $button.data('deal-id') + '/forms/insert-forms.js', {
      'form_ids[]': $.makeArray(form_ids),
      authenticity_token: csrfToken
  }).done(function() {
      // Only collapse once the forms actually inserted — was fire-and-forget, so on a failure the
      // section closed and the dealer assumed the forms were added when they weren't.
      $button.closest('.accordion-body').collapse('hide');
  }).fail(function(xhr) {
      showDealError(xhr, "Couldn't add the selected forms — please try again.");
  });

  e.preventDefault();
  e.stopPropagation();
  return false;
});

// "Forms for State" picker in the "Add additional forms" section. Changing the
// state must reload the forms list below to that state's forms. The select is a
// Choices.js widget (data-choices-target="choicesSearch"); Choices dispatches a
// native `change` on the underlying <select> when a choice is picked, so we bind
// with DELEGATION on the native select's `change` — a handler attached directly
// before Choices upgraded the element (or bound to the wrong node) would never
// fire. The endpoint responds with for_state.js.erb, which swaps the list HTML.
$('body').on('change', '#forms_state_selector', function () {
  var $select = $(this);
  var dealId = $select.data('deal-id');
  var state = $select.val();
  if (!dealId || !state) { return; }

  $('#form-fetch-progress-info').text(' Loading forms…');
  $.ajax({
    url: '/deals/' + dealId + '/forms/for_state',
    method: 'GET',
    data: { state: state },
    dataType: 'script'
  }).fail(function () {
    $('#form-fetch-progress-info').text(' Could not load forms for that state. Please try again.');
  });
});

$('body').on("change", ".use_me", function(){
  $(this).siblings(".destroy").val($(this).is(":checked") ? "0" : "1");
});

$("form.edit_deal .email-forms").on("click", function() {
  var $form = $(this).parents("form");

  $(".inner-main .alert").remove();
  if (!$form.find(".email-forms-to").val()) {
      $(".inner-main").prepend("<div class=\"alert alert-error\">Please specify an email address to send email to.</div>");
      window.scrollTo(0, 0);
      return false;
  } else if ($form.find("[data-paid-form=true]").is(":checked") && PAID_FORMS_ENABLED != true) {
      confirmPaidForms();
      return false;
  } else {
      $form.find("input[name=\"submit_type\"]").val("email");
      $form.find(".save-forms, .print-forms, .email-forms").prop("disabled", true).addClass("disabled");
      $form.find(".email-forms").html('<span class="deal-forms-spinner"></span>Emailing…');
      $form.submit();
  }
});

function confirmPaidForms() {
  // /deals/:deal_id
  // NOTE: this used to call `Util.alert(...)`, but `Util` (an old jQuery-UI dialog
  // wrapper) no longer exists in the bundle — so the moment a dealer had a paid
  // (LAW / Wolters Kluwer) form checked WITHOUT paid forms enabled, clicking
  // Save / Print / Email forms threw "Util is not defined" and the button did
  // nothing. Use a native confirm so the paid-forms opt-in works on both the
  // legacy and v2 deal pages.
  var link = document.location.pathname + '/forms/enable_paid_forms';
  var confirmed = window.confirm("You're attempting to use a paid form.\n\nPlease confirm that you'd like to use paid forms: LAW and Wolters Kluwer are $3/copy.");
  if (!confirmed) { return false; }
  var csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
  $.ajax({
      url: link + '.json',
      dataType: 'text',
      type: 'post',
      headers: { 'X-CSRF-Token': csrfToken },
      success: function() {
          document.location.reload(true);
      },
      error: function(xhr) {
          showDealError(xhr, "Couldn't enable paid forms — please try again.");
      }
  });
}
if ($.fn.tablesorter) {
  $("table.tablesorter").tablesorter({
    theme : 'default',
    headers: {
      4: { sorter: false, filter: false }
    }
  });
}

$(".use-form-folder").on("change", function() {
  var $checkbox = $(this);
  var checked = $checkbox.is(":checked");
  
  $(".use-form-in-folder-" + $checkbox.val()).prop("checked", checked);
  $(".use-form-in-folder-" + $checkbox.val()).parents(".form-in-folder").find(".destroy").val(checked ? "0" : "1");
  
  if (checked) {
      $checkbox.parents(".form").find(".form_fields").show();
  } else {
      $checkbox.parents(".form").find(".form_fields").hide();
  }
});

$(".use-form-in-folder").on("change", function() {
    var $checkbox = $(this);
    var checked = $checkbox.is(":checked");
    
    if (checked) {
        $checkbox.parents(".form-in-folder").find(".form_fields").show();
        $checkbox.parents(".form-in-folder").find(".destroy").val("0");
    } else {
        $checkbox.parents(".form-in-folder").find(".form_fields").hide();
        $checkbox.parents(".form-in-folder").find(".destroy").val("1");
    }

    var folderId = $checkbox.data("form-folder-id");
    var uncheckedSiblings = $.grep($(".use-form-in-folder-" + folderId), function(el) {
        return !$(el).is(":checked");
    });
    $("#use_form_folder_" + folderId).prop("checked", (!uncheckedSiblings || uncheckedSiblings.length === 0));
});

$(".use-form-folder").each(function() {
    var uncheckedChildren = $.grep($(".use-form-in-folder-" + $(this).val()), function(el) {
        return !$(el).is(":checked");
    });
    $(this).prop("checked", (!uncheckedChildren || uncheckedChildren.length === 0));
});

// ── Interest method <-> close date, and the day-count control ────────────────────────────────
// Two honesty fixes on the legacy deal editor (2026-08-15):
//
//   1. DAILY SIMPLE INTEREST IS CALCULATED FROM THE CLOSE DATE. Financing#adjust_daily_simple_interest
//      accrues interest over deferred_first_payment_n = first payment − close date − one period; with
//      no close date that is 0, so the deal pays out exactly like plain simple interest and the radio
//      looks dead. We never substitute a date (created_at / today would just be a confident wrong
//      number the bank won't match) — the form says which field the math is waiting on and jumps
//      there. Purely informational: desking before a close date exists is normal.
//   2. "Days per year" only does something for daily simple interest (and, on a BHPH note, a
//      percentage late fee via Financing#late_charge). It is hidden otherwise instead of sitting
//      there as a dead control — see the comment in _sale.html.haml.
$(document).ready(function() {
  var $note = $('#interest_close_note');
  var $daysRow = $('#days_in_a_year_row');
  if ($note.length === 0 && $daysRow.length === 0) return;

  function selectedInterestMethod() {
    return $('input[name="deal[interest_method]"]:checked').val() || 'simple_interest';
  }
  function selectedSaleType() {
    return $('[name="deal[type_of_sale]"]:checked').val();
  }
  function closeDateFilled() {
    return $.trim($('#deal_close_date').val() || '') !== '';
  }

  function updateInterestCloseNote() {
    var daily = selectedInterestMethod() === 'daily_simple_interest';
    if ($note.length) {
      if (!daily) {
        $note.hide();
      } else {
        var needs = !closeDateFilled();
        $note.toggleClass('needs', needs).show();
        $('#interest_close_note_text').text(needs
          ? 'Daily simple interest is calculated from the close date — set the close date above and this payment will update.'
          : 'Daily simple interest — this payment is calculated from the close date above.');
      }
    }
    if ($daysRow.length) {
      $daysRow.toggle(daily || selectedSaleType() === 'bhph');
    }
  }

  $('body').on('change', 'input[name="deal[interest_method]"], [name="deal[type_of_sale]"]', updateInterestCloseNote);
  $('body').on('input change', '#deal_close_date', updateInterestCloseNote);
  // The close date is a flatpickr/date-input; a pick fires change, but blur-after-type may not.
  $('body').on('blur', '#deal_close_date', updateInterestCloseNote);
  $('body').on('click', '.interest-close-jump', function(e) {
    e.preventDefault();
    var el = document.getElementById('deal_close_date');
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.focus();
  });

  updateInterestCloseNote();
});

$(document).ready(function() {
  if ($("#sale_information").length > 0) {
    toggleFinancingCalculationOptions();
    $("body").on("change", "#deal_calculate_financing_by_no_of_payments_true, #deal_calculate_financing_by_no_of_payments_false", function() {
      toggleFinancingCalculationOptions();
    });
  }

  function toggleFinancingCalculationOptions() {
    if ($("#deal_calculate_financing_by_no_of_payments_true").is(":checked")) {
      $("#sale_information .payment").hide();
      $("#sale_information .no_of_payments").show();
      $("#sale_information .interest-computation").show();
      $(".pricing-adjustment-active .target-options .no_of_payments_adjustment_field").hide();
      $(".pricing-adjustment-active .target-options .payment_adjustment_field").show();
    } else {
      $("#sale_information .payment").show();
      $("#sale_information .no_of_payments").hide();
      $("#sale_information .interest-computation").hide();
      $(".pricing-adjustment-active .target-options .no_of_payments_adjustment_field").show();
      $(".pricing-adjustment-active .target-options .payment_adjustment_field").hide();
    }
  }
});
$(".currency_decimal").each(function() {
      let val = $(this).val();

      // skip if already formatted
      if (val.includes('$')) return;

      let value = parseFloat(val);
      if (!isNaN(value)) {
        $(this).val(
          '$' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        );
      }
    });